import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TipoCartera } from '@p-p-portafolio/interfaces/tipoCartera';
import { EntityOperationResult } from '@shared/interfaces/responses/entity-operation-result';
import { environment } from 'src/environments/environment';
import {PermissionsResponse} from "../../parametria/portafolio/interfaces/permissions";
import { AuthLogin } from '@pages/authentication/interfaces/AuthLogin';
import { GetTokenADRequest } from '@pages/authentication/interfaces/GetTokenAD';
import { DataUser } from '@pages/authentication/interfaces/DataUser';
import { Observable, of } from 'rxjs';
import { TokenModel, UpdateToken } from '@pages/authentication/interfaces/UpdateToken';
import { Router, RouterLink } from '@angular/router';
import { ValidateTokenResponse } from '@pages/authentication/interfaces/ValidateToken';
import { CryptDataService } from '@shared/utils/crypt-data.service';
import { BrowserStorageService } from '@shared/utils/browser-storage.service';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class SecurityService {

//   private baseUrl = environment.apiBaseUrl + 'api/GetAccessByRol/GetModules/';

//   constructor(private http: HttpClient) { }

//   getByUser(email: string) {
//     localStorage.setItem('user', email);
//     const url = `${this.baseUrl}${email}`;
//     return this.http.get<PermissionsResponse[]>(url);
//   }

    private baseUrl = environment.apiBaseUrl + 'api/Token';
    /** GetTokenAD vive en el API nuevo (apiNewBackBaseUrl) cuando está disponible. */
    private baseUrlGetTokenAD = (environment as any).apiNewBackBaseUrl
      ? (environment as any).apiNewBackBaseUrl + 'Token/GetTokenAD'
      : this.baseUrl + '/GetTokenAD';
    private applicationKey = environment.cryptKey;

    constructor(private http: HttpClient, private router: Router, private _cryptService: CryptDataService, private storage: BrowserStorageService) { }

    authUser(authLogin: AuthLogin) {
        return this.http.post<DataUser>(this.baseUrl + '/GetToken', authLogin);
    }

    /**
     * Obtiene token y datos de usuario por email (autenticación AD / Microsoft).
     * Se usa después de validar contra LDAP (ICETEX) o de un SSO Microsoft.
     */
    getTokenAD(payload: GetTokenADRequest): Observable<DataUser> {
        return this.http.post<DataUser>(this.baseUrlGetTokenAD, payload);
    }

    validateToken(): Observable<boolean>{
        const token = this.storage.getSession('Token')
        if (token === null) {
            // this.router.navigateByUrl('/sesion-expirada');
            return of(false);
        } else {
            this.renewToken();
            return of(true);
        }
    }

    renewToken(): void {

        try{

            let tokenTime = this._cryptService.decryptDataSession(this.storage.getSession('TokenTime'))
    
            const dateLogin: Date = JSON.parse(this.storage.getSession('dateLogin'))
                
            let timeToExpiry = parseFloat(tokenTime) * 0.5
    
            let dateNow = moment(new Date()).format("YYYY-MM-DD")
    
            let fecha = new Date(dateLogin)
            
            let fechaRestante = new Date().getTime() - fecha.getTime();
    
            fechaRestante = (fechaRestante / 1000)
            // console.log(fechaRestante, 'fechaRestante')
            // console.log(timeToExpiry, 'timeToExpiry')
            if (fechaRestante >= timeToExpiry){
                this.validationToken()
            }

        } catch (error) {
            console.log(error)
        }    

    }

    validationToken(): Observable<UpdateToken> {
        const fecha: Date = new Date();

        const payload: AuthLogin = {
            email: JSON.parse(this.storage.getSession('Usser')),
            password: this.storage.getSession('codePublic'),
            token: JSON.parse(this.storage.getSession('Token')),
            applicationKey: this.applicationKey,
        };

        console.log(payload, 'payload')

        const resp = this.http.post<UpdateToken>(this.baseUrl + '/ValidateToken', payload);
            resp.subscribe((data) => {
                console.log(data)
                this.storage.setSession('Token', JSON.stringify(data.token.access_Token));
                this._cryptService.encryptDataSessionAES('TokenTime', JSON.stringify(data.token.expires_In), true);
                this._cryptService.saveToSession('dateLogin', JSON.stringify(fecha))
            },
            error => {
                console.log('@Error =>', error)
                this.storage.clearSession();
                this.router.navigateByUrl('/sesion-expirada');
            });
        
        return resp;
        
    }
}
